import { useOwnersStore } from "@shared/stores/owners.ts";
import { useSubscriptionsStore } from "@shared/stores/subscriptions.ts";
import { watch } from "vue";
import { permissions } from "@shared/services/permissions.ts";

export const useOwnersLoader = () => {
  const subscriptionsStore = useSubscriptionsStore();
  const ownersStore = useOwnersStore();

  watch(
    () => subscriptionsStore.currentSubscriptionNumberInt,
    (currentSubscriptionNumber, oldSubscriptionNumber) => {
      if (!currentSubscriptionNumber || !permissions.has("manageUsers:view")) {
        return;
      }
      if (oldSubscriptionNumber !== undefined) {
        ownersStore.resetAndRefetch();
      } else {
        ownersStore.fetchFirstPage();
      }
      void ownersStore.checkCurrentUserSso();
    },
    {
      immediate: true,
    },
  );
  return {};
};
